<template>
  <el-card shadow="hover" v-if="allFeeds.length" >
    <div slot="header" class="clearfix">
      <span class="feed-header">{{$t('feed.settings.common.title')}} №{{$route.params.threadId}}</span>
    </div>

    <common-simple :filter="keysF" @updateParent="onUpdate"/>

    <el-divider></el-divider>

    <recommendation />

    <el-divider></el-divider>

    <key-words ref="keywords"/>

    <el-button type="primary" @click="saveSettings">Сохранить настройки поиска</el-button>

    <el-divider></el-divider>

    <retrospective ref="retrospective"/>

    <el-button type="primary" @click="saveSettings">Сохранить периоды</el-button>

  </el-card>
</template>

<script>
  // forms
  import CommonSimple from './forms/CommonSimple';
  import Recommendation from './forms/Recommendation';
  import KeyWords from './forms/KeyWords';
  import Retrospective from './forms/Retrospective';

  // vuex
  import { mapGetters } from 'vuex';

  // api
  import { threadSetPeriodsApi, threadSetSourcesKeywordsAdvanced, threadSetFiltersAdvanced } from "../../../../../api/feeds";

  // libraries
  import moment from 'moment';

  // components
  import notify from "../../../../../helpers/notify";

  export default {
    name: 'Common',
    props: {
      active: {
        type: Boolean
      },
    },
    data() {
      return {
        keysF: [],
        approximation: -1
      }
    },
    computed: {
      ...mapGetters([
        'allFeeds',
      ]),
    },
    methods: {
      onUpdate(someData) {
        console.log('onUpdate', someData)
        this.approximation = someData
      },
      saveSettings() {
        let keywordsData = this.$refs.keywords.getData();
        let retrospectiveData = this.$refs.retrospective.getData();

        this.saveRetrospective(retrospectiveData);

        if (this.$refs.keywords.isKeyWordType) {
          this.saveKeywords(keywordsData);
          this.saveFilters(keywordsData);
        } else {
          this.saveFilters(keywordsData);
        }
      },
      saveKeywords(data) {
        let params = {
          thread_id: this.$route.params.threadId,
          keywords: data.keywords.map((item) => {
            //if (item.enabled) 
            {
              return {
                keyword: typeof(item.keyword) == 'object' ? item.keyword.keyword : item.keyword,
                enabled: item.enabled,
                networks: item.networks,
              }
            }
          }),
          stopkeywords: [],
        };
        threadSetSourcesKeywordsAdvanced(params).then(() => {
          notify.call(this, this.$t('feed.settings.common.updateNotify.keys'), "success");
        });
      },
      saveFilters(data) {
        let params = {
          thread_id: this.$route.params.threadId,
          filter: data.filters.map((item) => {
            return {
              keyword: item.keyword,
              enabled: item.enabled,
              //approximation: this.approximation
              approximation: item.approximation
            }
          }),
          stopfilter: data.stopkeywords.map((item) => {
            return {
              keyword: item.keyword,
              enabled: item.enabled,
            }
          }),
        };

        threadSetFiltersAdvanced(params).then(() => {
          this.keysF = this.$refs;
          notify.call(this, this.$t('feed.settings.common.updateNotify.stopWords'), "success");
        });
      },
      saveRetrospective(data) {
        let params = {
          thread_id: this.$route.params.threadId,
          periods: {
            sources: data.sources.value,
            profiles: data.profiles.value,
            retro: moment(data.date_retro).format('YYYY-MM-DD HH:MM'),
            retro_max: data.date_retro_to ? moment(data.date_retro_to).format('YYYY-MM-DD HH:MM') : null,
          }
        };

        threadSetPeriodsApi(params).then(() => {
          notify.call(this, this.$t('feed.settings.common.updateNotify.settings'), "success");
        });
      }
    },

    mounted() {
      this.keysF = this.$refs;
    },

    components: {
      CommonSimple,
      Recommendation,
      KeyWords,
      Retrospective,
    },
  };
</script>

<style>
  .feed-header {
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    color: #5E6D82;
  }
</style>
